import _ from 'lodash'

// No breakglass on the DAO obviously
export const daoTemplateWithoutBreakGlass = _.template(`{
    DROP;
    NIL operation;
    PUSH address "<%= contract %>";
    CONTRACT %setParameters (pair nat (pair nat (pair nat (pair nat (pair nat (pair nat (pair nat (pair nat nat))))))));
    IF_NONE { PUSH int 7; FAILWITH } {};
    PUSH mutez 0;
    PUSH
        (pair nat (pair nat (pair nat (pair nat (pair nat (pair nat (pair nat (pair nat nat))))))))
        (Pair
            <%= escrowAmount %> # escrowAmount
            (Pair
                <%= voteDelayBlocks %> # voteDelayBlocks
                (Pair
                    <%= voteLengthBlocks %> # voteLengthBlocks
                    (Pair
                        <%= minYayVotesPercentForEscrowReturn %> # minYayVotesPercentForEscrowReturn
                        (Pair
                            <%= blocksInTimelockForExecution %> # blocksInTimelockForExecution
                            (Pair
                                <%= blocksInTimelockForCancellation %> # blocksInTimelockForCancellation
                                (Pair
                                    <%= percentageForSuperMajority %> # percentageForSuperMajority
                                    (Pair
                                        <%= quorumCapLower %> # quorumCapLower
                                        <%= quorumCapUpper %> # quorumCapUpper
                                    )
                                )
                            )
                        )
                    )
                )
            )
        );
    TRANSFER_TOKENS;
    CONS;
}`)
